import React from 'react';
import { Link } from 'react-router';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import 'font-awesome/css/font-awesome.css';
import '../styles/app.css';

const NoMatch = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className="text-center">
            <h1>404 Page not found</h1>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NoMatch;